// ProductPopup.js
import React from 'react';
import './ProductPopup.css';

const ProductPopup = ({ product, fields, dropdownData, onClose }) => {
  if (!product) return null;

  const renderValue = (key, value) => {
    // Case 1: Dropdown Mapping
    if (dropdownData[key] && dropdownData[key][value]) {
      return dropdownData[key][value];
    }

    // Case 2: Array
    if (Array.isArray(value)) {
      return value.map(item => 
        typeof item === 'object' ? item.title || JSON.stringify(item) : item
      ).join(', ');
    }

    // Case 3: Object
    if (typeof value === 'object' && value !== null) {
      const secondEntry = Object.entries(value).find(([k]) => k !== "_id");
      return secondEntry ? secondEntry[1] : JSON.stringify(value);
    }

    // Default
    return value;
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        <h2>Entry Details</h2>
        <button className="close-btn" onClick={onClose}>✖</button>
        <table className="popup-table">
          <tbody>
            {fields.map(field => (
              <tr key={field.fields}>
                <td className="popup-key">{field.fields.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</td>
                <td className="popup-value">{renderValue(field.fields, product[field.fields])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductPopup;
